/* eslint-disable */
/* DO NOT EDIT. This file is automatically generated. */
import bancas__id from '@/pages/bancas/[id]/page.vue';
import bancas from '@/pages/bancas/page.vue';
import cargos__id from '@/pages/cargos/[id]/page.vue';
import cargos from '@/pages/cargos/page.vue';
import configuracoes__portal__status from '@/pages/configuracoes/portal/status/page.vue';
import conteudos__artigos__editar__id from '@/pages/conteudos/artigos/editar/[id]/page.vue';
import conteudos__artigos__novo from '@/pages/conteudos/artigos/novo/page.vue';
import conteudos__artigos from '@/pages/conteudos/artigos/page.vue';
import conteudos__atividades__id from '@/pages/conteudos/atividades/[id]/page.vue';
import conteudos__atividades from '@/pages/conteudos/atividades/page.vue';
import conteudos__avaliacao_aude__id from '@/pages/conteudos/avaliacao-aude/[id]/page.vue';
import conteudos__avaliacao_aude__grupo_de_questoes__id__status__gradelevel from '@/pages/conteudos/avaliacao-aude/grupo-de-questoes/[id]/[status]/[gradelevel]/page.vue';
import conteudos__avaliacao_aude__grupo_de_questoes__id__status__gradelevel__questao from '@/pages/conteudos/avaliacao-aude/grupo-de-questoes/[id]/[status]/[gradelevel]/questao/page.vue';
import conteudos__avaliacao_aude from '@/pages/conteudos/avaliacao-aude/page.vue';
import conteudos__materiais__editar__id from '@/pages/conteudos/materiais/editar/[id]/page.vue';
import conteudos__materiais__novo from '@/pages/conteudos/materiais/novo/page.vue';
import conteudos__materiais from '@/pages/conteudos/materiais/page.vue';
import conteudos__midias__id from '@/pages/conteudos/midias/[id]/page.vue';
import conteudos__midias from '@/pages/conteudos/midias/page.vue';
import conteudos__questoes__id from '@/pages/conteudos/questoes/[id]/page.vue';
import conteudos__questoes__criar from '@/pages/conteudos/questoes/criar/page.vue';
import conteudos__questoes__editar__id from '@/pages/conteudos/questoes/editar/[id]/page.vue';
import conteudos__questoes from '@/pages/conteudos/questoes/page.vue';
import escolas__id from '@/pages/escolas/[id]/page.vue';
import escolas from '@/pages/escolas/page.vue';
import exams__examId__groups__groupId__choice__choiceId from '@/pages/exams/[examId]/groups/[groupId]/choice/[choiceId]/page.vue';
import exams__examId__groups__groupId from '@/pages/exams/[examId]/groups/[groupId]/page.vue';
import exams__examId__groups__groupId__questao__questionId from '@/pages/exams/[examId]/groups/[groupId]/questao/[questionId]/page.vue';
import exams__examId from '@/pages/exams/[examId]/page.vue';
import exams from '@/pages/exams/page.vue';
import feedbackReports__id from '@/pages/feedbackReports/[id]/page.vue';
import feedbackReports from '@/pages/feedbackReports/page.vue';
import index from '@/pages/page.vue';
import painel from '@/pages/painel/page.vue';
import portal__usuarios__id from '@/pages/portal/usuarios/[id]/page.vue';
import portal__usuarios from '@/pages/portal/usuarios/page.vue';
import reinos__EducationSystem__educationSystemID__EducationStage__educationStageID__Grade__gradeID from '@/pages/reinos/EducationSystem/[educationSystemID]/EducationStage/[educationStageID]/Grade/[gradeID]/page.vue';
import reinos__EducationSystem__educationSystemID__EducationStage__educationStageID__Grade from '@/pages/reinos/EducationSystem/[educationSystemID]/EducationStage/[educationStageID]/Grade/page.vue';
import reinos__EducationSystem__educationSystemID__EducationStage from '@/pages/reinos/EducationSystem/[educationSystemID]/EducationStage/page.vue';
import reinos__EducationSystem from '@/pages/reinos/EducationSystem/page.vue';
import tag_type__id from '@/pages/tag-type/[id]/page.vue';
import tag_type from '@/pages/tag-type/page.vue';
import tags__id from '@/pages/tags/[id]/page.vue';
import tags from '@/pages/tags/page.vue';
import usuarios__id from '@/pages/usuarios/[id]/page.vue';
import usuarios from '@/pages/usuarios/page.vue';

export default [
  {
    path: '/bancas/:id',
    name: 'bancas.id',
    component: bancas__id
  },
  {
    path: '/bancas',
    name: 'bancas',
    component: bancas
  },
  {
    path: '/cargos/:id',
    name: 'cargos.id',
    component: cargos__id
  },
  {
    path: '/cargos',
    name: 'cargos',
    component: cargos
  },
  {
    path: '/configuracoes/portal/status',
    name: 'configuracoes.portal.status',
    component: configuracoes__portal__status
  },
  {
    path: '/conteudos/artigos/editar/:id',
    name: 'conteudos.artigos.editar.id',
    component: conteudos__artigos__editar__id
  },
  {
    path: '/conteudos/artigos/novo',
    name: 'conteudos.artigos.novo',
    component: conteudos__artigos__novo
  },
  {
    path: '/conteudos/artigos',
    name: 'conteudos.artigos',
    component: conteudos__artigos
  },
  {
    path: '/conteudos/atividades/:id',
    name: 'conteudos.atividades.id',
    component: conteudos__atividades__id
  },
  {
    path: '/conteudos/atividades',
    name: 'conteudos.atividades',
    component: conteudos__atividades
  },
  {
    path: '/conteudos/avaliacao-aude/:id',
    name: 'conteudos.avaliacao-aude.id',
    component: conteudos__avaliacao_aude__id
  },
  {
    path: '/conteudos/avaliacao-aude/grupo-de-questoes/:id/:status/:gradelevel',
    name: 'conteudos.avaliacao-aude.grupo-de-questoes.id.status.gradelevel',
    component: conteudos__avaliacao_aude__grupo_de_questoes__id__status__gradelevel
  },
  {
    path: '/conteudos/avaliacao-aude/grupo-de-questoes/:id/:status/:gradelevel/questao',
    name: 'conteudos.avaliacao-aude.grupo-de-questoes.id.status.gradelevel.questao',
    component: conteudos__avaliacao_aude__grupo_de_questoes__id__status__gradelevel__questao
  },
  {
    path: '/conteudos/avaliacao-aude',
    name: 'conteudos.avaliacao-aude',
    component: conteudos__avaliacao_aude
  },
  {
    path: '/conteudos/materiais/editar/:id',
    name: 'conteudos.materiais.editar.id',
    component: conteudos__materiais__editar__id
  },
  {
    path: '/conteudos/materiais/novo',
    name: 'conteudos.materiais.novo',
    component: conteudos__materiais__novo
  },
  {
    path: '/conteudos/materiais',
    name: 'conteudos.materiais',
    component: conteudos__materiais
  },
  {
    path: '/conteudos/midias/:id',
    name: 'conteudos.midias.id',
    component: conteudos__midias__id
  },
  {
    path: '/conteudos/midias',
    name: 'conteudos.midias',
    component: conteudos__midias
  },
  {
    path: '/conteudos/questoes/:id',
    name: 'conteudos.questoes.id',
    component: conteudos__questoes__id
  },
  {
    path: '/conteudos/questoes/criar',
    name: 'conteudos.questoes.criar',
    component: conteudos__questoes__criar
  },
  {
    path: '/conteudos/questoes/editar/:id',
    name: 'conteudos.questoes.editar.id',
    component: conteudos__questoes__editar__id
  },
  {
    path: '/conteudos/questoes',
    name: 'conteudos.questoes',
    component: conteudos__questoes
  },
  {
    path: '/escolas/:id',
    name: 'escolas.id',
    component: escolas__id
  },
  {
    path: '/escolas',
    name: 'escolas',
    component: escolas
  },
  {
    path: '/exams/:examId/groups/:groupId/choice/:choiceId',
    name: 'exams.examId.groups.groupId.choice.choiceId',
    component: exams__examId__groups__groupId__choice__choiceId
  },
  {
    path: '/exams/:examId/groups/:groupId',
    name: 'exams.examId.groups.groupId',
    component: exams__examId__groups__groupId
  },
  {
    path: '/exams/:examId/groups/:groupId/questao/:questionId',
    name: 'exams.examId.groups.groupId.questao.questionId',
    component: exams__examId__groups__groupId__questao__questionId
  },
  {
    path: '/exams/:examId',
    name: 'exams.examId',
    component: exams__examId
  },
  {
    path: '/exams',
    name: 'exams',
    component: exams
  },
  {
    path: '/feedbackReports/:id',
    name: 'feedbackReports.id',
    component: feedbackReports__id
  },
  {
    path: '/feedbackReports',
    name: 'feedbackReports',
    component: feedbackReports
  },
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/painel',
    name: 'painel',
    component: painel
  },
  {
    path: '/portal/usuarios/:id',
    name: 'portal.usuarios.id',
    component: portal__usuarios__id
  },
  {
    path: '/portal/usuarios',
    name: 'portal.usuarios',
    component: portal__usuarios
  },
  {
    path: '/reinos/EducationSystem/:educationSystemID/EducationStage/:educationStageID/Grade/:gradeID',
    name: 'reinos.EducationSystem.educationSystemID.EducationStage.educationStageID.Grade.gradeID',
    component: reinos__EducationSystem__educationSystemID__EducationStage__educationStageID__Grade__gradeID
  },
  {
    path: '/reinos/EducationSystem/:educationSystemID/EducationStage/:educationStageID/Grade',
    name: 'reinos.EducationSystem.educationSystemID.EducationStage.educationStageID.Grade',
    component: reinos__EducationSystem__educationSystemID__EducationStage__educationStageID__Grade
  },
  {
    path: '/reinos/EducationSystem/:educationSystemID/EducationStage',
    name: 'reinos.EducationSystem.educationSystemID.EducationStage',
    component: reinos__EducationSystem__educationSystemID__EducationStage
  },
  {
    path: '/reinos/EducationSystem',
    name: 'reinos.EducationSystem',
    component: reinos__EducationSystem
  },
  {
    path: '/tag-type/:id',
    name: 'tag-type.id',
    component: tag_type__id
  },
  {
    path: '/tag-type',
    name: 'tag-type',
    component: tag_type
  },
  {
    path: '/tags/:id',
    name: 'tags.id',
    component: tags__id
  },
  {
    path: '/tags',
    name: 'tags',
    component: tags
  },
  {
    path: '/usuarios/:id',
    name: 'usuarios.id',
    component: usuarios__id
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: usuarios
  }
];
